import { queryClient } from "@config/queryClient";
import useUserStore from "@store/useUserStore";
import useEmailStore from "@store/useEmailStore";
import usePlatformStore from "@store/usePlatformStore";
import useSystemStore from "@store/useSystemStore";
import useMeetingStore from "@store/useMeetingStore";
import { ActiveScreen } from "@enums/screens.enum";

export function useResetApp() {
  const { setPlatformData } = usePlatformStore();
  const { resetUser } = useUserStore();
  const { setIsAppLoading, setIsAppActive, changeActiveScreen } = useSystemStore();
  const { setEmailId, setThreadId } = useEmailStore();
  const { setMeetingId } = useMeetingStore();

  const resetApp = (targetScreen: ActiveScreen) => {
    // Email provider data
    setPlatformData({
      itemId: null,
      itemSubject: null,
      itemType: null,
      isComposeMode: false,
      calendarId: null,
    });
    setEmailId(null);
    setThreadId(null);

    // Meeting data
    setMeetingId(null);

    // App data
    setIsAppActive(false);
    setIsAppLoading(false);

    // User data (to be reset only if the user is logged out)
    resetUser();

    changeActiveScreen(targetScreen);
    queryClient.clear();
  };

  return { resetApp };
}
